<template>
  <div>
    <div class="section-heading">
      <h4>Search Terms</h4>
      <!-- <p>Add your product details</p> -->
      <p class="w-70 mt-3">
        Optimize your marketplace strategy by tracking your brand’s performance
        in the right categories and search terms<br />
        Choose the categories where your products compete and the keywords
        customers use to find them. Weavr will provide in-depth insights to help
        you stay ahead.
      </p>
    </div>
    <div class="mt-4">
      <p class="section-subheading">Platforms Selected</p>
      <div class="d-flex w-50 flex-wrap" v-if="selectedPlatforms.length">
        <button
          class="demo-btn active"
          v-for="platform of selectedPlatforms"
          :key="platform.platform_id"
        >
          {{ platform.platform_name }}
        </button>
      </div>
      <p v-else style="color: var(--red); font-size: 12px; font-weight: 400">
        Please select platform(s) to continue
      </p>
    </div>
    <div v-if="selectedPlatforms.length" class="section-heading mt-4">
      <div class="selected-category-section">
        <h3>Selected Keyterms</h3>
        <div class="table-container">
          <table class="platform-table">
            <tr>
              <th>Platforms</th>
              <th>Keyterms</th>
              <th>Selected Keyterms</th>
            </tr>
            <tr
              v-for="platform in selectedPlatforms"
              :key="'platform-' + platform.platform_id"
            >
              <td>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-1">
                  <img
                    :src="getImageUrl(platform.slug)"
                    width="20"
                    :alt="platform.platform_name + ' logo'"
                  />
                  <span class="mx-1"> {{ platform.platform_name }}</span>
                </div>
              </td>
              <td>
                <div class="scroll-container keyterms-input">
                  <span class="m-1">
                    <input
                      type="text"
                      placeholder="Enter Keyterms"
                      v-model="keyterms[platform.platform_id]"
                      @keyup.enter="handleSubmitKeyterms(platform)"
                    />
                  </span>
                </div>
              </td>
              <td>
                <div class="scroll-container">
                  <div v-if="Object.keys(storedKeyterms).length">
                    <div
                      v-for="(data, idx) in storedKeyterms[platform.platform_id]
                        .data"
                      :key="idx"
                      class="category-badge m-1"
                    >
                      <div
                        class="tw-flex tw-items-center tw-justify-center tw-gap-1"
                      >
                        <span v-if="data"> {{ data }}</span>
                        <img
                          src="/Icons_SVG/cross.svg"
                          alt="remove"
                          class="mx-1 cursor-pointer"
                          @click="handleRemoveKeyterms(platform, data)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <b-modal
        size="xl"
        class="customModal"
        id="keytermsModal"
        v-model="showModal"
        hide-footer
      >
        <template #modal-title>
          <div>
            <h5>Confirm Deletion</h5>
            <p class="modal-desc">
              The Keywords selected will be deleted from our records. Please
              note that the data for these pin codes will not be updated any
              further.<br />
              You can still access the past data on the dashboard.
            </p>
          </div>
        </template>
        <div class="selected-category-section">
          <h3>Selected Keyterms</h3>
          <div class="table-container tw-h-[280px] tw-overflow-y-auto">
            <div class="table-container">
              <table class="platform-table">
                <tr>
                  <th>Platforms</th>
                  <th>Selected Keyterms</th>
                </tr>
                <tr
                  v-for="platform in selectedPlatforms"
                  :key="'platform-' + platform.platform_id"
                >
                  <td>
                    <div
                      class="tw-flex tw-items-center tw-justify-center tw-gap-1"
                    >
                      <img
                        :src="getImageUrl(platform.slug)"
                        width="20"
                        :alt="platform.platform_name + ' logo'"
                      />
                      <span class="mx-1"> {{ platform.platform_name }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="scroll-container">
                      <span v-if="Object.keys(deletedKeyterms).length">
                        <div
                          v-for="(data, idx) in deletedKeyterms[
                            platform.platform_id
                          ]"
                          :key="idx"
                          class="category-badge m-1"
                        >
                          <div
                            class="tw-flex tw-items-center tw-justify-center tw-gap-1"
                          >
                            <span v-if="data"> {{ data }}</span>
                            <img
                              src="/Icons_SVG/cross.svg"
                              alt="remove"
                              class="mx-1 cursor-pointer"
                              @click="handleStoreKeyterms(platform, data)"
                            />
                          </div>
                        </div>
                      </span>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <button class="primarycolor mt-3 float-right" @click="saveKeyterms">
            Confirm
          </button>
        </div>
      </b-modal>
    </div>
    <div class="mt-4">
      <div class="d-flex">
        <button class="primarycolor mr-3" @click="handleModal">
          Save and Next
        </button>
        <button
          class="navigationButton"
          @click="setSelectedSection('Pincodes')"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "CatAndSearchTerms",
  data() {
    return {
      // currentSectionIndex: null,
      // nextSection: null,
      // previousSection: null,
      uploadedCatAndSearchTerms: "",
      invalidCheck: false,
      keyterms: {},
      storedKeyterms: {},
      showModal: false,
      deletedKeyterms: {},
      selectedKeyterms: [],
    };
  },
  computed: {
    ...mapState("DemoStore", ["selectedFeatures", "selectedPlatforms"]),
  },
  mounted() {
    if (!this.selectedPlatforms.length) {
      this.getFeatureWisePlatform();
    }
    this.setDemoLoader(true);
    Promise.all(
      this.selectedPlatforms.map((platform) =>
        this.getKeytermsData(platform.platform_id)
      )
    )
      .then(() => {
      })
      .catch((error) => {
        console.error("Error fetching category data:", error);
      })
      .finally(() => {
        this.setDemoLoader(false);
        this.$forceUpdate();
      });
  },
  methods: {
    ...mapActions("DemoStore", [
      "setDemoLoader",
      "setSelectedSection",
      "setTotalPlatforms",
      "setSelectedPlatforms",
    ]),

    getImageUrl(slug) {
      try {
        return require(`../../../../../public/platform_svg/${slug}.svg`);
      } catch (e) {
        return require("../../../../../public/img/default_platform.png");
      }
    },
    getFeatureWisePlatform() {
      this.setDemoLoader(true);
      const url = "/api/demo/feature_platform";
      const payload = {
        feature_ids: this.selectedFeatures.map((feature) => feature.feature_id),
        region_id: this.$store.state.DemoStore.selectedRegion.id,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          let resData = res.body.data;
          let filteredSelectedPlatforms = [];

          if (resData.length)
            filteredSelectedPlatforms = resData.filter(
              (platform) => platform.isSelected && platform
            );

          this.setTotalPlatforms(resData);
          this.setSelectedPlatforms(filteredSelectedPlatforms);
          this.setDemoLoader(false);
        })
        .catch((err) => {
          console.log("Erron in getting platforms", err);
          this.setDemoLoader(false);
        });
    },
    getKeytermsData(platformId) {
      return new Promise((resolve, reject) => {
        this.setDemoLoader(true);
        const url = `/api/v3/search_map?platform_id=${platformId}`;
        this.$http
          .get(url)
          .then((res) => {
            const keyterms = res.data;
            this.storedKeyterms[platformId] = keyterms;
            resolve();
          })
          .catch((err) => {
            console.log(err);
            this.setDemoLoader(false);
            reject(err);
          });
      });
    },
    handleModal() {
      const hasDeletedValues = Object.values(this.deletedKeyterms).some(
        (arr) => Array.isArray(arr) && arr.length > 0
      );

      if (hasDeletedValues) {
        this.showModal = true;
      } else {
        this.saveKeyterms();
      }
    },
    handleRemoveKeyterms(platform, term) {
      if (term) {
        const platformId = platform.platform_id;
        this.storedKeyterms[platformId].data = this.storedKeyterms[
          platformId
        ].data.filter((item) => item !== term);

        if (!this.deletedKeyterms[platformId]) {
          this.deletedKeyterms[platformId] = [];
        }
        this.deletedKeyterms[platformId].push(term);
        this.$forceUpdate();
      }
    },
    handleStoreKeyterms(platform, term) {
      const platformId = platform.platform_id;

      if (term) {
        if (!this.storedKeyterms[platformId]) {
          this.storedKeyterms[platformId] = { data: [] };
        }

        if (!this.deletedKeyterms[platformId]) return;

        if (!this.storedKeyterms[platformId].data.includes(term)) {
          this.storedKeyterms[platformId].data.push(term);
        }

        this.deletedKeyterms[platformId] = this.deletedKeyterms[
          platformId
        ].filter((item) => item !== term);
        this.$forceUpdate();
      }
    },
    handleSubmitKeyterms(platform) {
      const keyword = this.keyterms[platform.platform_id].trim();
      if (
        keyword &&
        !this.storedKeyterms[platform.platform_id].data.includes(keyword)
      ) {
        this.storedKeyterms[platform.platform_id].data.push(keyword);
        this.selectedKeyterms.push({
          platform_id: platform.platform_id,
          keyword: keyword,
        });
      } else {
        this.$bvToast.toast(`You have already this keyword.`, {
          title: "Weavr Sense",
          variant: "danger",
          toaster: "b-toaster-top-center",
          autoHideDelay: 3000,
        });
      }

      this.keyterms[platform.platform_id] = "";
    },
    async handleConfirmDelete() {
      this.setDemoLoader(true);
      const url = "/api/v3/search_map";
      const user = localStorage.getItem("reviewUserData");
      const token = JSON.parse(user);
      const data = Object.entries(this.deletedKeyterms).flatMap(
        ([platform_id, keywords]) =>
          keywords.map((keyword) => ({
            platform_id,
            keyword,
          }))
      );

      const payload = { data: data };
      if (payload.length === 0) {
        console.warn("Payload is empty, skipping API call.");
        return;
      }
      try {
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            TOKEN: token.data.token,
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
      } catch (err) {
        console.error("Error:", err);
      } finally {
        this.setDemoLoader(false);
      }
    },
    saveKeyterms() {
      const hasDeletedValues = Object.values(this.deletedKeyterms).some(
        (arr) => Array.isArray(arr) && arr.length > 0
      );

      if (hasDeletedValues) {
        this.handleConfirmDelete();
      }
      const url = "/api/v3/search_map";
      const payload = {
        data: this.selectedKeyterms,
      };

      this.$http
        .post(url, payload)
        .then((response) => {
          this.setSelectedSection("Frequency");
        })
        .catch((error) => {
          console.error("Error saving keyterms:", error);
        });
    },
  },
};
</script>

<style scoped>
.demo-input {
  padding: 4px 10px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  color: var(--primary_brand);
}

.demo-input::placeholder {
  color: #919191;
  font-family: "Poppins", sans-serif;
}

.demo-input:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
}

.demo-btn {
  color: #919191;
  background-color: transparent;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 6px 12px;
  margin-right: 20px;
  margin-bottom: 12px;
}

.demo-btn.active {
  background-color: var(--primary_brand);
  border: 1px solid var(--primary_brand);
  color: white;
  font-weight: 500;
}

.demo-btn:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ebebeb !important;
}

.demo-btn.active:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: var(--primary_brand) !important;
}
.scroll-container input {
  border-radius: 5px;
  border: 1px solid #aeaeae;
  padding: 12px 16px;
  max-width: 250px;
  min-width: 250px;
}

.keyterms-input {
  display: flex;
  justify-content: center;
  min-width: 300px;
  max-width: 300px;
}
.scroll-container input:focus {
  box-shadow: none !important;
  border: 1px solid #aeaeae !important;
}

.section-heading h4 {
  font-size: 20px;
  color: #000000;
  font-weight: 500;
}
.section-subheading {
  font-weight: 500;
  color: #000000;
  font-size: 14px;
}
.section-heading p {
  color: #5e5e5e;
  font-size: 14px;
  font-weight: 500;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins", sans-serif;
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.navigationButton:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.selected-category-section > h3 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin: 16px 0;
}
.platform-table {
  width: 100%;
  max-width: 1440px;
  border-collapse: collapse;
}

.platform-table th {
  background: rgba(6, 85, 89, 0.1);
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  padding: 14px;
  border-collapse: collapse;
  border: 1px solid #d5d5d5;
}

.platform-table td {
  padding: 16px;
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  border-collapse: collapse;
  border: 1px solid #d5d5d5;
}

.platform-table td:first-child {
  width: 500px;
  white-space: nowrap;
  text-align: center;
}

.platform-table td:last-child {
  max-width: 340px;
  overflow-x: auto;
  white-space: nowrap;
}
.platform-table tbody td {
  border: none !important;
}

.table-container {
  overflow: hidden;
  max-width: 1440px;
  border-radius: 3px;
}
.customModal {
  overflow: auto;
  max-width: 200px;
}
.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
}

.category-badge {
  border: 1px solid rgba(174, 174, 174, 1);
  border-radius: 20px;
  padding: 8px 12px;
  display: inline-block;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #949292 #ffffff;
}

*::-webkit-scrollbar {
  width: 0px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #949292 #ffffff;
  border-radius: 10px;
  border: 1px solid #ffffff;
}

button.primarycolor {
  height: 35px;
  border: none !important;
  margin: 0;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

button.primarycolor:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
<style>
#keytermsModal .modal-header {
  padding-bottom: 0 !important;
}
#keytermsModal .modal-title {
  color: #00555a !important;
  font-weight: 500;
  font-size: 16px !important;
  font-family: "poppins", sans-serif !important;
  padding-bottom: 0 !important;
}
#keytermsModal .modal-desc {
  font-size: 14px !important;
  font-weight: 400 !important;
  font-family: "poppins", sans-serif;
  line-height: 20px !important;
  color: #505050 !important;
  margin-top: 12px !important;
}
#keytermsModal .modal-dialog {
  margin-top: 200px !important;
}
</style>
